
<template>
  <div class="invitacion-container" ref="containerRef">
    <div class="invitacion-card" ref="cardRef">

      <p ref="titulo" class="titulo-principal">
        GRACIAS POR<br>
        ACOMPAÑARME
      </p>

      <img
        src="@/assets/A4993CC0-69CD-4A54-8D6A-DEE5B5757B95.png"
        class="imagen-subcorona"
        alt="Detalle decorativo"
        ref="imagenSubCoronaRef"
      />

    </div>
  </div>
</template>

<script>
import { onMounted, onBeforeUnmount, ref } from 'vue';
import gsap from 'gsap';

export default {
  name: 'InvitacionIdioma',

  setup() {
    const containerRef = ref(null);
    const cardRef = ref(null);
    const titulo = ref(null);
    const imagenSubCoronaRef = ref(null);

    let timeline = null;

    onMounted(() => {

      gsap.set(
        [titulo.value, imagenSubCoronaRef.value],
        {
          opacity: 0,
          visibility: 'visible'
        }
      );

      timeline = gsap.timeline({
        delay: 0.4
      });

      timeline
        .fromTo(
          titulo.value,
          {
            opacity: 0,
            y: 30,
            filter: 'blur(8px)'
          },
          {
            opacity: 1,
            y: 0,
            filter: 'blur(0px)',
            duration: 1.4,
            ease: 'power3.out'
          }
        )
        .fromTo(
          imagenSubCoronaRef.value,
          {
            opacity: 0,
            scale: 0.85,
            y: 25,
            filter: 'blur(5px)'
          },
          {
            opacity: 1,
            scale: 1,
            y: 0,
            filter: 'blur(0px)',
            duration: 1.5,
            ease: 'power3.out'
          },
          '-=0.6'
        );

    });

    onBeforeUnmount(() => {
      if (timeline) {
        timeline.kill();
      }
    });

    return {
      containerRef,
      cardRef,
      titulo,
      imagenSubCoronaRef
    };
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@600;700&family=Great+Vibes&family=Playfair+Display:ital,wght@0,500;0,600;0,700;1,400;1,500&family=Montserrat:wght@400;500;600;700&display=swap');

.invitacion-container {
  display: flex;
  justify-content: center;
  align-items: center;

  min-height: 40vh;
  min-height: 40dvh;

  width: 100%;
  padding: 1rem;
  margin: 0;

  box-sizing: border-box;

  background-color: #d8e9f3;

  background-image:
    linear-gradient(
      rgba(0, 0, 0, 0.566),
      rgba(0, 0, 0, 0.594)
    ),
    url('@/assets/B3D70B5E-2599-498C-923E-4B6C6082F8F9.png');

  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  position: relative;
  overflow: hidden;
}

.invitacion-card {
  position: relative;

  padding: 40px 24px;
  margin: 0 auto;

  background-color: transparent;

  text-align: center;

  width: 100%;
  max-width: 420px;

  z-index: 1;

  box-sizing: border-box;

  display: flex;
  flex-direction: column;
  align-items: center;

  will-change: opacity, transform;
}

/* MENSAJE PRINCIPAL */

.titulo-principal {
  font-family: 'Cinzel', 'Playfair Display', serif;

  font-size: 1.15rem;

  color: #e4e7ea;

  margin: 0 0 25px 0;

  letter-spacing: 3px;
  line-height: 1.8;

  font-weight: 600;

  text-transform: uppercase;
  text-align: center;
}

/* IMAGEN DECORATIVA */

.imagen-subcorona {
  width: 240px;
  max-width: 100%;

  height: auto;

  margin: 0 auto;

  display: block;

  object-fit: contain;

  filter: drop-shadow(
    0 3px 8px rgba(0, 0, 0, 0.15)
  );
}

/* RESPONSIVE */

@media (max-width: 480px) {

  .invitacion-card {
    padding: 2rem 1rem;
  }

  .titulo-principal {
    font-size: 1rem;
    letter-spacing: 2px;
    margin-bottom: 20px;
  }

  .imagen-subcorona {
    width: 200px;
  }

}
</style>
